var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 227"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.681,
    cy: 29.271,
    r: 28.861,
    fill: "#FD0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.861,
    cy: 109.974,
    r: 28.861,
    fill: "#FD0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.861,
    cy: 197.473,
    r: 28.861,
    fill: "#FD0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.681,
    cy: 109.974,
    r: 28.861,
    fill: "#FD0"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM2IiBoZWlnaHQ9IjIyNyIgdmlld0JveD0iMCAwIDEzNiAyMjciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjEwNi42ODEiIGN5PSIyOS4yNzExIiByPSIyOC44NjEiIGZpbGw9IiNGRkREMDAiLz4KPGNpcmNsZSBjeD0iMjguODYxIiBjeT0iMTA5Ljk3NCIgcj0iMjguODYxIiBmaWxsPSIjRkZERDAwIi8+CjxjaXJjbGUgY3g9IjI4Ljg2MSIgY3k9IjE5Ny40NzMiIHI9IjI4Ljg2MSIgZmlsbD0iI0ZGREQwMCIvPgo8Y2lyY2xlIGN4PSIxMDYuNjgxIiBjeT0iMTA5Ljk3NCIgcj0iMjguODYxIiBmaWxsPSIjRkZERDAwIi8+Cjwvc3ZnPgo=";
export { SvgYellowDots as ReactComponent };